<div class="form-control input">
  <input
    id="txtDateInput"
    type="tel"
    spellcheck="false"
    name="calBirthDate"
    maxlength="10"
    placeholder="Fecha de nacimiento (dd/mm/aaaa)"
    min-age="0"
    max-age="90"
    class="text-input inline text-09-d-demibold txtDate"
    [class.error]="validationUiService.isInsuredSubmit && !validationUiService.isPrimaryInsuredDob(contractType)"
    inputmode="numeric"
    date-mask
    [(ngModel)]="DOB"
    (ngModelChange)="onSubmitAnswer($event)" />
  <!--<p class="error-txt"></p>-->
  <!--<p id="error-date1" class="error-txt">Por favor, introduce una fecha correcta</p>-->
</div>
